import { render, staticRenderFns } from "./TailwindInput.vue?vue&type=template&id=0d363146&scoped=true&"
import script from "./TailwindInput.vue?vue&type=script&lang=ts&"
export * from "./TailwindInput.vue?vue&type=script&lang=ts&"
import style0 from "./TailwindInput.vue?vue&type=style&index=0&id=0d363146&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d363146",
  null
  
)

export default component.exports